import type { GlobalState } from '../index';
import type { IState } from '../reducers/locations';

export const getCurrentUserLocation = (state: GlobalState): IState['currentUserLocation'] =>
  state.locations.currentUserLocation;
